/**
 * Import Types
 *
 * Types for importing operations from external sources (CSV, OFX, QIF).
 *
 * @module types/import
 */
/**
 * Available target fields with their labels
 */
export const IMPORT_TARGET_FIELDS = [
    { key: 'paymentDate', labelKey: 'import.fields.paymentDate', required: true },
    { key: 'accountingDate', labelKey: 'import.fields.accountingDate', required: false },
    { key: 'amount', labelKey: 'import.fields.amount', required: true },
    { key: 'direction', labelKey: 'import.fields.direction', required: false },
    { key: 'counterpartyName', labelKey: 'import.fields.counterparty', required: true },
    { key: 'categoryName', labelKey: 'import.fields.category', required: false },
    { key: 'paymentMethodName', labelKey: 'import.fields.paymentMethod', required: false },
    { key: 'projectName', labelKey: 'import.fields.project', required: false },
    { key: 'paymentDetails', labelKey: 'import.fields.paymentDetails', required: false },
    { key: 'reference', labelKey: 'import.fields.reference', required: false },
    { key: 'comment', labelKey: 'import.fields.comment', required: false },
    { key: 'ignore', labelKey: 'import.fields.ignore', required: false },
];
/**
 * Common date formats for auto-detection
 */
export const DATE_FORMATS = [
    'DD/MM/YYYY',
    'MM/DD/YYYY',
    'YYYY-MM-DD',
    'DD-MM-YYYY',
    'DD.MM.YYYY',
    'YYYYMMDD',
    'MMM DD, YYYY', // English format: "Feb 11, 2026" - also handles split columns from Revolut CSV
];
/**
 * Common CSV delimiters
 */
export const CSV_DELIMITERS = [';', ',', '\t', '|'];
/**
 * Default import/export preferences
 */
export const DEFAULT_IMPORT_EXPORT_PREFERENCES = {
    importDuplicateHandling: 'import',
    importAutoCreateCategories: false,
    importAutoCreatePaymentMethods: false,
    importDefaultDateFormat: 'DD/MM/YYYY',
    importDefaultDelimiter: ';',
    exportDefaultFormat: 'csv',
    exportDefaultDelimiter: ';',
    exportSignedAmounts: true,
};
//# sourceMappingURL=import.js.map